import { useState, useCallback, useRef, useEffect } from 'react';

/**
 * Custom hook to manage modal state with protection against multiple rapid clicks
 * This prevents users from accidentally triggering multiple modal opens
 */
export const useModalWithProtection = (initialState = false) => {
    const [isOpen, setIsOpen] = useState(initialState);
    const isOpeningRef = useRef(false);

    const openModal = useCallback(() => {
        // Prevent opening modal if it's already open or being opened
        if (isOpen || isOpeningRef.current) {
            return;
        }

        isOpeningRef.current = true;
        setIsOpen(true);

        // Reset the flag after a short delay
        setTimeout(() => {
            isOpeningRef.current = false;
        }, 500);
    }, [isOpen]);

    const closeModal = useCallback(() => {
        setIsOpen(false);
        isOpeningRef.current = false;
    }, []);

    // Cleanup effect to reset the ref when component unmounts
    useEffect(() => {
        return () => {
            isOpeningRef.current = false;
        };
    }, []);

    return {
        isOpen,
        openModal,
        closeModal,
    };
};
